import Mutations from '../../odata/mutations';

export default { ...new Mutations('customerLocation'), ...new Mutations('customerLocations') };
